import { constants } from "@newsela/angelou";

const {
  colors: { ui },
} = constants;

// TO DO: SWAP WITH ANGELOU COLORS
export const TEACHER_USAGE_DATA_CARD_COLOR = "#DAF4F8";
export const STUDENT_USAGE_DATA_CARD_COLOR = ui.beige[50];

// TO DO: SWAP WITH ANGELOU COLORS
export const TEACHER_USAGE_BAR_ONE_COLOR = "#48C8E4";
// TO DO: SWAP WITH ANGELOU COLORS
export const TEACHER_USAGE_BAR_TWO_COLOR = "#34A1B9";
export const TEACHER_USAGE_BAR_THREE_COLOR = ui.teal[700];
export const STUDENT_USAGE_SHIMMER_COLOR = ui.green[50];
// TO DO: SWAP WITH ANGELOU COLORS
export const STUDENT_USAGE_BAR_ONE_COLOR = "#46BFA2";
export const STUDENT_USAGE_DOUBLE_BAR_TWO_COLOR = ui.green[600];
// TO DO: SWAP WITH ANGELOU COLORS
export const STUDENT_USAGE_TRIPLE_BAR_TWO_COLOR = "#3D9887";
export const STUDENT_USAGE_BAR_THREE_COLOR = ui.green[600];
